window.navigation = () => {
    return {
        scrolled: false,
        mobMenuOpen: false,
        megamenu: null,
        navContainer: null,
        navColorSwap: false,
        init() {
            this.navContainer = this.$refs.navContainer;
        },
        lockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = 'hidden';
        },
        unlockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = 'auto';
        },
        openMegaMenu(id) {

            if(this.megamenu !== null && this.megamenu !== id) {
                this.megamenu = null;

                setTimeout(() => {
                    this.megamenu = this.megamenu === id ? null : id;
                },400);
            } else {
                this.megamenu = this.megamenu === id ? null : id;

                if(this.megamenu === null) {
                    this.closeMegaMenu();
                    return;
                }
            }

            this.navColorSwap = true;

            setTimeout(() => {
                this.navContainer.classList.add('delay-300');
            }, 300);

            
        },
        closeMegaMenu() {
            this.megamenu = null;
            setTimeout(() => {
                this.navColorSwap = false;
                this.navContainer.classList.remove('delay-300');
            },300)
        },
    }
}